import { render, staticRenderFns } from "./GuideVideoBanner.vue?vue&type=template&id=1a97e95b&scoped=true"
import script from "./GuideVideoBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideVideoBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GuideVideoBanner.vue?vue&type=style&index=0&id=1a97e95b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97e95b",
  null
  
)

export default component.exports